/* eslint no-useless-escape: "off" */
/* eslint  @typescript-eslint/camelcase: "off" */
export const Postcode = /(GIR 0AA|[A-PR-UWYZ]([0-9]{1,2}|([A-HK-Y][0-9]|[A-HK-Y][0-9]([0-9]|[ABEHMNPRV-Y]))|[0-9][A-HJKS-UW])\s?[0-9][ABD-HJLNP-UW-Z]{2})/;

export const Email = /^[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?$/;

export const Password = /^(?=.{8,})(?=(.*\d){2,})(?=.*[a-z])(?=.*[A-Z])(?!.*\s)(?!.*\W).*$/;

export const NationalInsuranceNumber = /^((A[ABEHKLMPRSTWXYZ])|(B[ABEHKLMT])|(C[ABCEHKLR])|(E[ABEHKLMPRSTWXYZ])|(GY)|(H[ABEHKLMPRSTWXYZ])|(J[ABCEGHJKLMNPRSTWXYZ])|(K[ABCEHKLMPRSTWXYZ])|(L[ABEHKLMPRSTWXYZ])|(M[AMWX])|(N[ABEHLMNPRSWXYZ])|(O[ABEHKLMPRSX])|(P[ABCEGHJKLMNPRSTWXY])|(R[ABEHKMPRSTWXYZ])|(S[ABCEGHJKLMNPRSTWXYZ])|(T[ABEHKLMPRSTWXYZ])|(W[ABEKLMP])|(Y[ABEHKLMPRSTWXYZ])|(Z[ABEHKLMPRSTWXY]))\d{6}[A-D]+$/i;

export const Alphabetical = /^[A-Za-z]*$/;

export const NonePureAlphabetical = /^.*[^\d].*$/;

export const Numeric = /^[0-9]*$/;

export const GuidOrNumeric = /^([0-9A-F]{8}-[0-9A-F]{4}-[0-9A-F]{4}-[0-9A-F]{4}-[0-9A-F]{12})|([0-9]+)$/;

export const AlphanumericWithSpace = /^[A-Za-z0-9 ]*$/;

export const AlphanumericWithApostrophe = /^[A-Za-z0-9' ]*$/;

export const Alphanumeric = /^[A-Za-z0-9]*$/;

export const AlphanumericWithSpecialCharacters = /^[A-Za-z0-9!"£\$%\^&\*\(\)_\+-=\{\}\[\]:@\\`~;'#\|,\.\/<>\? ]*$/;

export const Alphabetical1 = /^[A-Za-z]{1}$/;

export const Alphabetical2 = /^[A-Za-z]{2}$/;

export const Numeric8 = /^[0-9]{8}$/;

export const Numeric2 = /^[0-9]{2}$/;

export const Numeric4 = /^[0-9]{4}$/;

export const Numeric6 = /^[0-9]{6}$/;

export const Numeric7 = /^[0-9]{7}$/;

export const Numeric20 = /^[0-9]{20}$/;

export const Numeric1_6 = /^[0-9]{1,6}$/;

export const Name50 = /^[a-zA-Z0-9 \&_,'-]{0,50}$/;

export const TownOfBirth = /^.{0,50}$/;

export const ClientAccountId = /^[A-Z]{2}[0-9]{7}$/;

export const UkMobileNumber = /^07[0-9]{9}$/;

export const LandLineNumber = /^[+]?[0-9]{10,11}$/;

export const UkPostCode = /^(GIR ?0AA|[A-PR-UWYZ]([0-9][A-HJKPS-UW]|[0-9]{1,2}|[A-HK-Y][0-9]([0-9ABEHMNPRV-Y])?) [0-9][ABD-HJLNP-UW-Z]{2})$/i;

export const WithoutSpace = /.*\S.*/;

export const NoSpecialCharactersNoLeadingTrailingSpaces = /(^[^0-9\\!#$%&*+\/=?^_`{|}~ ;:\(\)\[\]"<>]+[^0-9\\@!#$%&*+\/=?^_`{|}~;:\(\)\[\]"<>]*[^0-9\\@!#$%&*+\/=?^_`{|}~ ;:\(\)\[\]"<>]+$)|(^[^0-9\\!#$%&*+\/=?^_`{|}~ ;:\(\)\[\]"<>]$)/;

export const NoSpecialCharacters = /(^[^0-9\\!#$%&*+\/=?^_`{|}~;:\(\)\[\]"<>]*[^0-9\\@!#$%&*+\/=?^_`{|}~ ;:\(\)\[\]"<>]+[^0-9\\@!#$%&*+\/=?^_`{|}~;:\(\)\[\]"<>]*$)/;

export const NoSpecial = /(^[^\\!#$%&*+\/=?^_`{|}~;:\(\)\[\]"<>]*[^\\@!#$%&*+\/=?^_`{|}~ ;:\(\)\[\]"<>]+[^\\@!#$%&*+\/=?^_`{|}~;:\(\)\[\]"<>]*$)/;

export const Phone = /^[\d|+]*$/;

export const UKMobilePhone = /^0\d{10}$/;

export const UKLandLinePhone = /^0\d*$/;

export const phoneWithSpaceAndPlusSign = /^\+?[\d| ]*$/;

export const NumericWithComma = /^[0-9,]*$/;

export const NumericWithSpace = /^[0-9 ]*$/;

export const AddressLine1to3 = /^[A-Za-z0-9 \-\'\.]*$/;

export const AddressLine = /^[A-Za-z0-9 \-\.]*$/;

export const LeiCode = /^[A-Za-z0-9]{20}$/;

export const EndWithTwoNumbers = /^.*[0-9][0-9]$/;

export const FcaReferenceNumber = /^[A-Za-z0-9]{8}/;

export const AllowOneSpecial = /^[a-zA-z0-9 ]*[~|<>:?=!@#$%^&\()\-+]?[a-zA-z0-9 ]*$/;

export const NumericWithDot = /^[0-9\.]*$/;

export const Numeric8AtLeastOneNonZero = /^(?!0{8})[0-9][0-9]{7}$/;

export const AlphanumericWithSeperator = /^[A-Za-z0-9.]{19}$/;

export const AllowTwoSpecial = /^[a-zA-z0-9 ]*[~|<>:?=!@#$%^&\()\-+]?[a-zA-z0-9 ]*[~|<>:?=!@#$%^&\()\-+]?[a-zA-z0-9 ]*$/;

export const AllowFourSpecial = /^[a-zA-Z0-9 ]*([\\~\|<>:\?=!@#\$%&\(\)\-\+_\^\[\]\.,`´\*\{\}/˙°\ˇ§][a-zA-Z0-9 ]*){0,4}$/;